  var swiper = new Swiper('.mySwiper1', {
    slidesPerView: 1.2,
    spaceBetween: 20,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      1024: {
        slidesPerView: 1.5,
        spaceBetween: 20,
      },
      1440: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
    },
  });